import Helpers from "../helpers";
import Splide from "@splidejs/splide";
import "@splidejs/splide/dist/css/splide.min.css";
export default class Footer {
    constructor(element) {
        this.element = document.querySelector(element);
        if (!this.element) return;
        this.splide;
        this.arrows;
        this.navHome = document.querySelector("#footer__home");
        this.navBrands = document.querySelector("#footer__brands");
        this.navWho = document.querySelector("#footer__who-we-are");
        this.navContact = document.querySelector("#footer__contact");
        this.footerHQtext = document.querySelectorAll(".footer__address-perex");
        this.footerHQheading = document.querySelectorAll(
            ".footer__address-title"
        );
        this.footerCarousel = document.querySelector(".footer__headquarters");

        this.splide;
        this.init();
    }

    init() {
        this.bindEvents();
        this.changeSliderSize();

        if (window.innerWidth > 769) {
            this.footerHQtext.forEach(text => {
                text.classList.add("footer__address-perex--no-drag");
            });
            this.footerHQtext.forEach(heading => {
                heading.classList.add("footer__address-perex--no-drag");
            });
        }
    }

    bindEvents() {
        if (
            window.location.pathname == "/en" ||
            window.location.pathname == "/de"
        ) {
            this.navHome.addEventListener("click", e => {
                e.preventDefault();
                document
                    .getElementById("home")
                    .scrollIntoView({ behavior: "smooth" });
            });
            this.navBrands.addEventListener("click", e => {
                e.preventDefault();
                document
                    .getElementById("brands")
                    .scrollIntoView({ behavior: "smooth" });
            });
            this.navWho.addEventListener("click", e => {
                e.preventDefault();
                document
                    .getElementById("who-we-are")
                    .scrollIntoView({ behavior: "smooth" });
            });
        }

        this.navContact.addEventListener("click", e => {
            e.preventDefault();
            document
                .getElementById("contact")
                .scrollIntoView({ behavior: "smooth" });
        });

        document.addEventListener("DOMContentLoaded", () => {
            this.mountSlider();
        });

        window.addEventListener("resize", e =>
            this.debounce(this.changeSliderSize(e), 250)
        );
    }

    mountSlider() {
        if (this.footerCarousel.classList.contains("is-active")) return;
        this.splide = new Splide(".splide", {
            type: "slide",
            perPage: 3,
            perMove: 1,
            gap: "1em",
            noDrag:
                ".footer__address-perex--no-drag , .footer__address-title--no-drag ",
            classes: {
                arrows: "splide__arrows footer__carousel-arrows",
                prev:
                    "splide__arrow--prev footer__carousel-arrow footer__carousel-arrow-prev",
                next:
                    "splide__arrow--next footer__carousel-arrow footer__carousel-arrow-next",
                pagination: "footer__carousel-pagination"
            },
            breakpoints: {
                729: {
                    perPage: 2
                },
                592: {
                    perPage: 1,
                    // autoWidth: true,
                    fixedWidth: "70%",
                    padding: "0 1rem 0 0",
                    arrows: false
                }
            }
        }).mount();
        const { Arrows } = this.splide.Components;
        this.arrows = Arrows.arrows;

        if (
            Object.keys(this.arrows).length === 0 &&
            this.arrows.constructor === Object
        )
            return;
        this.arrows.prev.classList.add("footer__carousel-arrow--hidden");

        this.splide.on("move", () => {
            if (window.innerWidth > 729) {
                if (this.splide.index == 4) {
                    this.arrows.next.classList.add(
                        "footer__carousel-arrow--hidden"
                    );
                } else {
                    this.arrows.next.classList.remove(
                        "footer__carousel-arrow--hidden"
                    );
                }
            }
            if (window.innerWidth > 592 && window.innerWidth < 729) {
                if (this.splide.index == 5) {
                    this.arrows.next.classList.add(
                        "footer__carousel-arrow--hidden"
                    );
                } else {
                    this.arrows.next.classList.remove(
                        "footer__carousel-arrow--hidden"
                    );
                }
            }

            if (this.splide.index == 0) {
                this.arrows.prev.classList.add(
                    "footer__carousel-arrow--hidden"
                );
            } else {
                this.arrows.prev.classList.remove(
                    "footer__carousel-arrow--hidden"
                );
            }
        });

        this.splide.on("move", () => {
            if (!window.innerWidth < 592) {
                if (this.splide.index == 5) {
                    this.splide.Components.Elements.root.classList.remove(
                        "footer__headquarters--mask-on"
                    );
                } else {
                    this.splide.Components.Elements.root.classList.add(
                        "footer__headquarters--mask-on"
                    );
                }
            }
        });
    }
    changeSliderSize() {
        if (window.innerWidth < 769) {
            this.footerHQtext.forEach(text => {
                text.classList.remove("footer__address-perex--no-drag");
            });
            this.footerHQheading.forEach(heading => {
                heading.classList.remove("footer__address-perex--no-drag");
            });
        } else {
            this.footerHQtext.forEach(text => {
                text.classList.add("footer__address-perex--no-drag");
            });
            this.footerHQheading.forEach(heading => {
                heading.classList.add("footer__address-perex--no-drag");
            });
        }
        if (window.innerWidth < 592) {
            this.footerCarousel.style.width = `${window.innerWidth - 92}px`;
            // this.footerCarousel.style.margin = "auto";
        } else {
            this.footerCarousel.style.width = "100%";
        }
    }
    debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this,
                args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }
}
